"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT = exports.SEGMENT_ES = exports.SEGMENT_EN = void 0;
exports.SEGMENT_EN = [
    {
        label: 'Advocacy and legal',
        value: 'legal',
    },
    {
        label: 'Agronegócio',
        value: 'agro',
    },
    {
        label: 'Alimentos e bebidas',
        value: 'food_drink',
    },
    {
        label: 'Animais de estimação',
        value: 'pet',
    },
    {
        label: 'Comércio',
        value: 'commerce',
    },
    {
        label: 'Consultoria',
        value: 'consult',
    },
    {
        label: 'Educação',
        value: 'education',
    },
    {
        label: 'Entretenimento',
        value: 'entertainment',
    },
    {
        label: 'Games e esportes',
        value: 'games',
    },
    {
        label: 'Imobiliário e incorporadoras',
        value: 'real_state',
    },
    {
        label: 'Logística',
        value: 'logistic',
    },
    {
        label: 'Manufatura',
        value: 'manufacture',
    },
    {
        label: 'Meio ambiente',
        value: 'environment',
    },
    {
        label: 'Mídia e comunicação',
        value: 'marketing',
    },
    {
        label: 'Mobilidade urbana',
        value: 'mobility',
    },
    {
        label: 'Moda e beleza',
        value: 'beauty',
    },
    {
        label: 'ONGs',
        value: 'ong',
    },
    {
        label: 'Saúde',
        value: 'health',
    },
    {
        label: 'Seguros',
        value: 'insurence',
    },
    {
        label: 'Serviços financeiros',
        value: 'financial',
    },
    {
        label: 'Serviços profissionais',
        value: 'pro_services',
    },
    {
        label: 'Setor público',
        value: 'public_sector',
    },
    {
        label: 'Tecnologia',
        value: 'technology',
    },
    {
        label: 'Telecomunicações',
        value: 'media',
    },
    {
        label: 'Turismo e lazer',
        value: 'tourism',
    },
    {
        label: 'Outros',
        value: 'others',
    },
];
exports.SEGMENT_ES = [
    {
        label: 'Abogacía y legal',
        value: 'legal',
    },
    {
        label: 'Agronegócio',
        value: 'agro',
    },
    {
        label: 'Alimentos e bebidas',
        value: 'food_drink',
    },
    {
        label: 'Animais de estimação',
        value: 'pet',
    },
    {
        label: 'Comércio',
        value: 'commerce',
    },
    {
        label: 'Consultoria',
        value: 'consult',
    },
    {
        label: 'Educação',
        value: 'education',
    },
    {
        label: 'Entretenimento',
        value: 'entertainment',
    },
    {
        label: 'Games e esportes',
        value: 'games',
    },
    {
        label: 'Imobiliário e incorporadoras',
        value: 'real_state',
    },
    {
        label: 'Logística',
        value: 'logistic',
    },
    {
        label: 'Manufatura',
        value: 'manufacture',
    },
    {
        label: 'Meio ambiente',
        value: 'environment',
    },
    {
        label: 'Mídia e comunicação',
        value: 'marketing',
    },
    {
        label: 'Mobilidade urbana',
        value: 'mobility',
    },
    {
        label: 'Moda e beleza',
        value: 'beauty',
    },
    {
        label: 'ONGs',
        value: 'ong',
    },
    {
        label: 'Saúde',
        value: 'health',
    },
    {
        label: 'Seguros',
        value: 'insurence',
    },
    {
        label: 'Serviços financeiros',
        value: 'financial',
    },
    {
        label: 'Serviços profissionais',
        value: 'pro_services',
    },
    {
        label: 'Setor público',
        value: 'public_sector',
    },
    {
        label: 'Tecnologia',
        value: 'technology',
    },
    {
        label: 'Telecomunicações',
        value: 'media',
    },
    {
        label: 'Turismo e lazer',
        value: 'tourism',
    },
    {
        label: 'Outros',
        value: 'others',
    },
];
exports.SEGMENT = [
    {
        label: 'Advocacia e jurídico',
        value: 'legal',
    },
    {
        label: 'Agronegócio',
        value: 'agro',
    },
    {
        label: 'Alimentos e bebidas',
        value: 'food_drink',
    },
    {
        label: 'Animais de estimação',
        value: 'pet',
    },
    {
        label: 'Comércio',
        value: 'commerce',
    },
    {
        label: 'Consultoria',
        value: 'consult',
    },
    {
        label: 'Educação',
        value: 'education',
    },
    {
        label: 'Entretenimento',
        value: 'entertainment',
    },
    {
        label: 'Games e esportes',
        value: 'games',
    },
    {
        label: 'Imobiliário e incorporadoras',
        value: 'real_state',
    },
    {
        label: 'Logística',
        value: 'logistic',
    },
    {
        label: 'Manufatura',
        value: 'manufacture',
    },
    {
        label: 'Meio ambiente',
        value: 'environment',
    },
    {
        label: 'Mídia e comunicação',
        value: 'marketing',
    },
    {
        label: 'Mobilidade urbana',
        value: 'mobility',
    },
    {
        label: 'Moda e beleza',
        value: 'beauty',
    },
    {
        label: 'ONGs',
        value: 'ong',
    },
    {
        label: 'Saúde',
        value: 'health',
    },
    {
        label: 'Seguros',
        value: 'insurence',
    },
    {
        label: 'Serviços financeiros',
        value: 'financial',
    },
    {
        label: 'Serviços profissionais',
        value: 'pro_services',
    },
    {
        label: 'Setor público',
        value: 'public_sector',
    },
    {
        label: 'Tecnologia',
        value: 'technology',
    },
    {
        label: 'Telecomunicações',
        value: 'media',
    },
    {
        label: 'Turismo e lazer',
        value: 'tourism',
    },
    {
        label: 'Outros',
        value: 'others',
    },
];
//# sourceMappingURL=segment.js.map